import { render, staticRenderFns } from "./ImportSiteflowAttributesModal.vue?vue&type=template&id=45925b44"
import script from "./ImportSiteflowAttributesModal.vue?vue&type=script&lang=js"
export * from "./ImportSiteflowAttributesModal.vue?vue&type=script&lang=js"
import style0 from "./ImportSiteflowAttributesModal.vue?vue&type=style&index=0&id=45925b44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports